module.exports = {
	"debug": {
		"debug": "1",
		"logips": 1,
		"logtimemicros": 1
	},
	"chain": {
		"chain": "regtest"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/regtest.json
 ** module id = 47
 ** module chunks = 0
 **/